var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('eagle-form',{attrs:{"form-key":_vm.formKey}}),(false)?_c('div',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.shareConfig))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }